/* eslint-env browser */
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import theme from './popover.theme';

export const POPOVER_MODE = {
  inline: 'inline',
  popup: 'popup',
};

const HTMLElementPropType = (prop) => typeof prop.nodeType !== 'undefined';

export const propOptions = {
  orientation: ['top', 'right', 'bottom', 'left'],
  mode: [POPOVER_MODE.inline, POPOVER_MODE.popup],
};

export const defaultProps = {
  orientation: 'bottom',
  position: 50,
  displayBlock: false,
  mode: POPOVER_MODE.inline,
  // TODO: Theme int support
  transitionTimeout: parseInt(theme.motionDuration, 10) + 100,
  id: '',
  popOverClassName: '',
  constraint: window,
  constraintPadding: { top: 0, bottom: 0, left: 0, right: 0 },
  showOnHover: true,
  secondary: false,
  tertiary: false,
  alert: false,
  warning: false,
  testID: undefined,
  showCloseButton: false,
  hideDelay: 250,
  onOuterAction: noop,
  onVisibilityChange: noop,
  open: undefined,
};

export const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  popOverClassName: PropTypes.string,
  id: PropTypes.string,
  orientation: PropTypes.oneOf(propOptions.orientation),
  position: PropTypes.number,
  displayBlock: PropTypes.bool,
  mode: PropTypes.oneOf(propOptions.mode),
  constraint: PropTypes.oneOfType([
    PropTypes.string,
    HTMLElementPropType,
    PropTypes.object,
    PropTypes.string,
  ]),
  constraintPadding: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  transitionTimeout: PropTypes.number.isRequired,
  showOnHover: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  alert: PropTypes.bool,
  warning: PropTypes.bool,
  testID: PropTypes.string,
  showCloseButton: PropTypes.bool,
  hideDelay: PropTypes.number,
  onOuterAction: PropTypes.func,
  onVisibilityChange: PropTypes.func,
  open: PropTypes.bool,
};

// Popper js supplies an empty string for the first render,
// so we this private type to prevent a warning
export const privateOrientationType = PropTypes.oneOf(
  propOptions.orientation.concat('')
);

export const contextTypes = {
  inverse: PropTypes.bool,
};
